<template>
  <div id="app">
    <!-- <el-header v-if="isVanish"></el-header> -->
    <el-main v-if="config.isVanish && config.isLogin"></el-main>
    <Wrap v-if="!config.isVanish"></Wrap>
  </div>
</template>

<script>
import Wrap from './new-login-2018/Wrap'
import elHeader from './components/Header'
import elMain from './components/Main'
import config from './assets/js/config'
export default {
  name: 'app',
  components: {
    Wrap: Wrap,
    elHeader: elHeader,
    elMain: elMain
  },
  data () {
    return {
      config: config
    }
  }
}
</script>

<style lang="scss">
#app {
  // .main {
  //   font-size: 0.1em;
  // }
}
</style>



// WEBPACK FOOTER //
// App.vue?7a828bc6